import React, { useEffect, useMemo } from 'react';

import type {
	FolderRovoConfigProviderProps,
	RovoConfiguration,
	RovoConfigurationProviderProps,
} from '../shared-types/rovoConfigTypes.tsx';
import { useRovoConfigProviderProps } from './RovoConfigProviderContextProvider.tsx';

export const FolderRovoConfigProvider = ({
	setConfiguration,
}: RovoConfigurationProviderProps): React.JSX.Element | null => {
	const { actionsToRender } = useRovoConfigProviderProps() as FolderRovoConfigProviderProps;

	const config = useMemo<RovoConfiguration>(
		() => ({
			getActions: async () => actionsToRender,
		}),
		[actionsToRender],
	);

	useEffect(() => {
		setConfiguration(config);
	}, [config, setConfiguration]);

	return null;
};
